import { render, staticRenderFns } from "./newSchoolPackage.vue?vue&type=template&id=97f54544&scoped=true"
import script from "./newSchoolPackage.vue?vue&type=script&lang=js"
export * from "./newSchoolPackage.vue?vue&type=script&lang=js"
import style0 from "./newSchoolPackage.vue?vue&type=style&index=0&id=97f54544&prod&lang=scss&scoped=true"
import style1 from "./newSchoolPackage.vue?vue&type=style&index=1&id=97f54544&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f54544",
  null
  
)

export default component.exports